import script from "./TaxDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./TaxDashboard.vue?vue&type=style&index=0&id=3cc9466d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc9466d"]])

export default __exports__